module.exports = __webpack_public_path__ + "img/icon-20-faq-mobile.15ff88ae.svg";